/**
 * WRITE A MODULE IN YOUR FEATURE FOLDER
 * -------------------------------------
 * Write each feature's scripts inside an exported const function like this:
 * export const myFeature = () => { my init code };
 * or
 * export const initMyFeature = () => { my init code };
 *
 * REQUIRE THE MODULE IN YOUR VIEW
 * -------------------------------
 * Add the module name in the view of the page, block or component that uses the script
 * by adding a data-require attribute (comma separated).
 * <div data-require="myfeature">
 * or
 * <div data-require="myfeature,accordion">
 *
 * INITIALIZE THE MODULE IN THIS FILE
 * ----------------------------------
 * Import the init function for your module in this file and
 * add the alias (used in data-require) and the function below.
 *
 * REFERENCING ELEMENTS ON THE PAGE
 * --------------------------------
 * Tag elements in the code using data attributes like this:
 * <button data-js-myfeature="toggle-button">Toggle</button>
 * and select it with a css selector "[data-js-myfeature=toggle-button]"
 */

import { accordion } from "../Accordion/accordion";
import { author } from "../Author/author";
import { calendarPage } from "../Investors/Calendar/calendarPage";
import { certificateFinder } from "../Certificates/Landing/certificateFinder";
import { contactForm } from "../Contact/contactForm";
import { counter } from "../Statistics/counter";
import { dropdown } from "./Dropdown/dropdown";
import { emergencyBanner } from "./Navigation/EmergencyBanner/emergencyBanner";
import { featuredCarousel } from "../FeaturedCarousel/featuredCarousel";
import { footer } from "./Navigation/Footer/footer";
import { formDataLayerPush } from "../Forms/Scripts/FormDataLayerPush";
import { gtmSessionStorage } from "./GoogleTagManager/gtmSessionStorage";
import { heroSlides } from "../Hero/heroSlides";
import { imageZoom } from "../Products/Product/ImageZoom/imagezoom";
import { infogram } from "../Infogram/infogram";
import { initializeModules, ModuleIndex } from "./initModule";
import { jobFinder } from "../Jobs/JobAdvertList/jobFinder";
import { locationFinder } from "../Locations/Landing/locationFinder";
import { menu } from "./Navigation/Menu";
import { newsFinder } from "../News/Listing/newsFinder";
import { productFinder } from "../Products/Finder/productFinder";
import { productPage } from "../Products/Product/productPage";
import { productSearch } from "../Products/Finder/Block/productSearch";
import { reportList } from "../Investors/Reports/reportList";
import { searchPage } from "../Search/searchPage";
import { slideshow as productSlideshow } from "../Products/Product/slideshow";
import { socialShare } from "./SocialMedia/socialShare";
import { switcher } from "../Switcher/switcher";
import { toggleTabs } from "../Tabs/toggleTabs";
import { videoBackground } from "../Video/videoBackground";
import { videoInline } from "../Video/videoInline";
import { videoModal } from "../Video/videoModal";
import { slideshow as imageSlideshow } from "../Slideshow/slideshow";
import { hubSpotForms } from "../HubSpot/Forms/hubSpotForms";

const modules: ModuleIndex = {
  // Add your module initializer here.
  // Aliases are case sensitive.
  // "alias": initFunction,
  accordion: accordion,
  author: author,
  calendarPage: calendarPage,
  certificateFinder: certificateFinder,
  contactForm: contactForm,
  counter: counter,
  dropdown: dropdown,
  emergencyBanner: emergencyBanner,
  featuredCarousel: featuredCarousel,
  footer: footer,
  formDataLayerPush: formDataLayerPush,
  gtmSessionStorage: gtmSessionStorage,
  heroSlides: heroSlides,
  hubSpotForms: hubSpotForms,
  imageSlideshow: imageSlideshow,
  imageZoom: imageZoom,
  infogram: infogram,
  jobFinder: jobFinder,
  locationFinder: locationFinder,
  menu: menu,
  newsFinder: newsFinder,
  productFinder: productFinder,
  productPage: productPage,
  productSearch: productSearch,
  productSlideshow: productSlideshow,
  reportList: reportList,
  searchPage: searchPage,
  socialShare: socialShare,
  switcher: switcher,
  toggleTabs: toggleTabs,
  videoBackground: videoBackground,
  videoInline: videoInline,
  videoModal: videoModal,
};

initializeModules(modules);
